import { render, staticRenderFns } from "./RepeatIcon.vue?vue&type=template&id=6534e806"
import script from "./RepeatIcon.vue?vue&type=script&lang=js"
export * from "./RepeatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports